import styles from "../../../movein-checklist.module.css";
import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { X } from "react-feather";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useAuth0 } from "@auth0/auth0-react";

const schema = yup.object().shape({
  bathroomfloorCovering: yup.string(),
  bathroomfloorCoveringOther: yup.string(),
  bathroomWallsCeiling: yup.string(),
  bathroomWallsCeilingOther: yup.string(),
  bathroomWindow: yup.string(),
  bathroomWindowOther: yup.string(),
  bathroomWindowConvering: yup.string(),
  bathroomWindowConveringOther: yup.string(),
  bathroomLightingFans: yup.string(),
  bathroomLightingFansOther: yup.string(),
  bathroomDoorHardware: yup.string(),
  bathroomDoorHardwareOther: yup.string(),
  bathroomHeating: yup.string(),
  bathroomHeatingOther: yup.string(),
  bathroomOutletsSwitches: yup.string(),
  bathroomOutletsSwitchesOther: yup.string(),
  bathroomSmokeAlarm: yup.string(),
  bathroomSmokeAlarmOther: yup.string(),
  bathroomCabinetsHardware: yup.string(),
  bathroomCabinetsHardwareOther: yup.string(),
  bathroomCounterSurfaces: yup.string(),
  bathroomCounterSurfacesOther: yup.string(),
  bathroomSinkFixtures: yup.string(),
  bathroomSinkFixturesOther: yup.string(),
  bathroomBathtubShower: yup.string(),
  bathroomBathtubShowerOther: yup.string(),
  bathroomToilet: yup.string(),
  bathroomToiletOther: yup.string(),
  bathroomOther: yup.string(),
  bathroomOtherOther: yup.string(),
});

const BathroomForm = ({ onSubmitArrivalForm, setLoading, moveInCheckListInfo, handleChange4 }) => {
  const [uploadedImages, setUploadedImages] = useState([]);
  const { getAccessTokenSilently } = useAuth0();

  const { control, handleSubmit, setValue } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const bathroomValues = useWatch({
    control,
  });

  useEffect(() => {
    if (!moveInCheckListInfo?.bathroom_data) return;

    const data = moveInCheckListInfo.bathroom_data;

    Object.entries(data).forEach(([key, field]) => {
      if (!field || typeof field !== "object") return;
    });

  }, [moveInCheckListInfo, setValue]);

  const onSubmit = (data) => {
    const sectionName = "bathroom_data";

    const formattedData = {
      bathroomfloorCovering: {
        value: data.bathroomfloorCovering === "other" ? data.bathroomfloorCoveringOther : data.bathroomfloorCovering,
        is_other: data.bathroomfloorCovering === "other" ? 1 : 0,
      },
      bathroomWallsCeiling: {
        value: data.bathroomWallsCeiling === "other" ? data.bathroomWallsCeilingOther : data.bathroomWallsCeiling,
        is_other: data.bathroomWallsCeiling === "other" ? 1 : 0,
      },
      bathroomWindow: {
        value: data.bathroomWindow === "other" ? data.bathroomWindowOther : data.bathroomWindow,
        is_other: data.bathroomWindow === "other" ? 1 : 0,
      },
      bathroomWindowConvering: {
        value: data.bathroomWindowConvering === "other" ? data.bathroomWindowConveringOther : data.bathroomWindowConvering,
        is_other: data.bathroomWindowConvering === "other" ? 1 : 0,
      },
      bathroomLightingFans: {
        value: data.bathroomLightingFans === "other" ? data.bathroomLightingFansOther : data.bathroomLightingFans,
        is_other: data.bathroomLightingFans === "other" ? 1 : 0,
      },
      bathroomDoorHardware: {
        value: data.bathroomDoorHardware === "other" ? data.bathroomDoorHardwareOther : data.bathroomDoorHardware,
        is_other: data.bathroomDoorHardware === "other" ? 1 : 0,
      },
      bathroomHeating: {
        value: data.bathroomHeating === "other" ? data.bathroomHeatingOther : data.bathroomHeating,
        is_other: data.bathroomHeating === "other" ? 1 : 0,
      },
      bathroomOutletsSwitches: {
        value: data.bathroomOutletsSwitches === "other" ? data.bathroomOutletsSwitchesOther : data.bathroomOutletsSwitches,
        is_other: data.bathroomOutletsSwitches === "other" ? 1 : 0,
      },
      bathroomSmokeAlarm: {
        value: data.bathroomSmokeAlarm === "other" ? data.bathroomSmokeAlarmOther : data.bathroomSmokeAlarm,
        is_other: data.bathroomSmokeAlarm === "other" ? 1 : 0,
      },
      bathroomCabinetsHardware: {
        value: data.bathroomCabinetsHardware === "other" ? data.bathroomCabinetsHardwareOther : data.bathroomCabinetsHardware,
        is_other: data.bathroomCabinetsHardware === "other" ? 1 : 0,
      },
      bathroomCounterSurfaces: {
        value: data.bathroomCounterSurfaces === "other" ? data.bathroomCounterSurfacesOther : data.bathroomCounterSurfaces,
        is_other: data.bathroomCounterSurfaces === "other" ? 1 : 0,
      },
      bathroomSinkFixtures: {
        value: data.bathroomSinkFixtures === "other" ? data.bathroomSinkFixturesOther : data.bathroomSinkFixtures,
        is_other: data.bathroomSinkFixtures === "other" ? 1 : 0,
      },
      bathroomBathtubShower: {
        value: data.bathroomBathtubShower === "other" ? data.bathroomBathtubShowerOther : data.bathroomBathtubShower,
        is_other: data.bathroomBathtubShower === "other" ? 1 : 0,
      },
      bathroomToilet: {
        value: data.bathroomToilet === "other" ? data.bathroomToiletOther : data.bathroomToilet,
        is_other: data.bathroomToilet === "other" ? 1 : 0,
      },
      bathroomOther: {
        value: data.bathroomOther === "other" ? data.bathroomOtherOther : data.bathroomOther,
        is_other: data.bathroomOther === "other" ? 1 : 0,
      },
    };

    const imageFiles = uploadedImages.map((img) => img.file_path);
    const imageSectionName = "bathroom_images";

    onSubmitArrivalForm(formattedData, sectionName, imageFiles, imageSectionName);

  };

  const handleImageChange = async (event) => {
    const files = Array.from(event.target.files);
    setLoading(true);

    try {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      for (const file of files) {
        const formData = new FormData();
        formData.append("image", file);

        const response = await axios.post(process.env.REACT_APP_PAYMENT_API_URL + `v1/move-in-report-file-upload`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          }
        });

        const { file_path, file_url } = response.data.data;

        setUploadedImages((prev) => [...prev, { file_path, file_url }]);
      }
      toast.success(`Images are uploaded`);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Image upload failed");
      }
    } finally {
      setLoading(false);
    }
  };

  const removeImage = (fileNameToRemove) => {
    setUploadedImages((prev) => prev.filter((img) => img.file_path !== fileNameToRemove));
  };

  return (<div className={`${styles.FormSec}`}>
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>1. Floor and Floor Covering</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bathroomfloorCovering"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bathroomValues?.bathroomfloorCovering === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bathroomfloorCoveringOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>2. Walls and Ceiling/Caulking</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bathroomWallsCeiling"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bathroomValues?.bathroomWallsCeiling === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bathroomWallsCeilingOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>3. Window(s)</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bathroomWindow"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bathroomValues?.bathroomWindow === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bathroomWindowOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>4. Window Covering(s)</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bathroomWindowConvering"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bathroomValues?.bathroomWindowConvering === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bathroomWindowConveringOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>5. Lighting Fixture(s)/Fans</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bathroomLightingFans"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bathroomValues?.bathroomLightingFans === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bathroomLightingFansOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>6. Door(s)/Hardware</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bathroomDoorHardware"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bathroomValues?.bathroomDoorHardware === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bathroomDoorHardwareOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>7. Heating</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bathroomHeating"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bathroomValues?.bathroomHeating === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bathroomHeatingOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>8. Outlets/Switches</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bathroomOutletsSwitches"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bathroomValues?.bathroomOutletsSwitches === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bathroomOutletsSwitchesOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>9. Smoke Alarms/CO Alarms</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bathroomSmokeAlarm"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bathroomValues?.bathroomSmokeAlarm === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bathroomSmokeAlarmOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>10. Cabinets/Hardware</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bathroomCabinetsHardware"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bathroomValues?.bathroomCabinetsHardware === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bathroomCabinetsHardwareOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>11. Counter Surfaces</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bathroomCounterSurfaces"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bathroomValues?.bathroomCounterSurfaces === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bathroomCounterSurfacesOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>12. Sink/Fixtures/Plumbing</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bathroomSinkFixtures"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bathroomValues?.bathroomSinkFixtures === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bathroomSinkFixturesOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>13. Bathtub/Shower/Fixtures</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bathroomBathtubShower"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bathroomValues?.bathroomBathtubShower === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bathroomBathtubShowerOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>14. Toilet</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="bathroomToilet"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {bathroomValues?.bathroomToilet === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="bathroomToiletOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>15. Other</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <Controller
                name="bathroomOther"
                control={control}
                render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
              />
            </FormControl>
          </div>
        </div>
      </div>

      <div className={`${styles.HalfSecFull}`}>
        <div className={`${styles.FileUpDuBUDiv}`}>
          <label htmlFor="file-upload-bathroom" className={`${styles.UploadLabel}`}>
            <span>
              <div className={`${styles.UpIcon}`}>
                <img src="/static/img/upload-floor.svg" alt="" />
              </div>
              <p>Upload Pictures</p>
              <p className={`${styles.UploadText}`}>File size upto 5 MB</p>
            </span>
          </label>
          <input id="file-upload-bathroom" type="file" accept="image/*" multiple onChange={handleImageChange} style={{ display: "none" }} />
        </div>

        <div className={`${styles.UpIMGSec}`}>
          {uploadedImages.map((img, index) => (<div key={index} className={`${styles.ImgFile}`}>
            <img src={img.file_url} alt={img.file_path} />
            <Button type="button" onClick={() => removeImage(img.file_path)}><X /></Button>
          </div>))}
        </div>
      </div>

      <div className={`${styles.ButtonAction}`}>
        <Button className={`${styles.CancelPopupBU}`} onClick={handleChange4("panel3")}>Cancel</Button>
        <Button type="submit" className={`${styles.SubmitPopupBU}`}>Save & Continue</Button>
      </div>
    </form>
  </div>);
};

export default BathroomForm;